module.exports = __webpack_public_path__ + "static/media/poker-table.d805fdc3.png";